import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

import {
  dispatchDisplay,
  getDisplaySession,
  startSession
} from '../../lib/display-mode.ts'

export const Route = createFileRoute('/display/$name')({
  component: DisplayEntry
})

/**
 * DisplayEntry — start this TV's rotation.
 *
 * The route renders nothing of its own. The runtime, mounted for the whole
 * signed-in session, loads the playlist and navigates to each page. Unmounting
 * this route is that navigation, so the cleanup must not stop the rotation.
 *
 * @returns Nothing.
 */
function DisplayEntry(): null {
  const { name } = Route.useParams()

  useEffect(() => {
    dispatchDisplay(startSession(getDisplaySession(), name))
  }, [name])

  return null
}
